import {
  CookieName,
  hotelCertificateStatusEnum,
  statusEnum,
  auditStatusEnum,
  approvalAuditStatusEnum,
  userStatusEnum,
  userTypeEnum,
  auditResultEnum,
  ReportPageTypes,
  isReadEnum,
  ImageStatusFilterEnum,
  hotelRevisedEnum,
  hotelRevisedStatusEnum,
  iktmStatus,
  ConsentLetterStatusFilterEnum,
} from './enums'
import { getUserInfo } from 'app/functions/session'

const userRole: any = getUserInfo()?.userRole

export const langs = [
  { label: 'English', value: 'en-US' },
  { label: 'Türkçe', value: 'tr-TR' },
]
export const facilityTypes = [
  { label: 'Konaklama', value: '3' },
  { label: 'Restoran', value: '4' },
]
export const facilityTypesEn = [
  { label: 'Accomodation', value: '3' },
  { label: 'Restaurant', value: '4' },
]

export const isOpenEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Open', value: true },
        { label: 'Close', value: false },
      ]
    : [
        { label: 'Açık', value: true },
        { label: 'Kapalı  ', value: false },
      ]

export const isYesNoEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ]
    : [
        { label: 'Evet', value: true },
        { label: 'Hayır', value: false },
      ]

export const isYesNoEnumList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Yes', value: 1 },
        { label: 'No', value: 2 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Evet', value: 1 },
        { label: 'Hayır', value: 2 },
      ]
export const InProgressStateInfoEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Verification In Process for Stage 1', value: 1 },
        { label: 'Verification In Process for Stage 2', value: 2 },
        { label: 'In the Certification Process', value: 3 },
      ]
    : [
        { label: '1. Aşama için Belgelendirme Sürecinde', value: 1 },
        { label: '2. Aşama için Belgelendirme Sürecinde', value: 2 },
        { label: 'Sertifikalandırma Sürecinde', value: 3 },
      ]

export const supervisionStatusEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Initial Check Completed ', value: 1 },
        { label: 'Firs Supervision Pending ', value: 2 },
        { label: 'First Supervision Completed', value: 3 },
        { label: 'First Supervision not Completed', value: 4 },
        { label: 'Second Supervision Pending', value: 5 },
        { label: 'Second Supervision Completed', value: 6 },
        { label: 'Second Supervision not Completed', value: 7 },
      ]
    : [
        { label: 'İlk Belgelendirme Tetkiki Tamamlandı', value: 1 },
        { label: '1. Gözetim Bekleniyor', value: 2 },
        { label: '1. Gözetim Tamamlandı', value: 3 },
        { label: '1. Gözetim Tamamlanamadı', value: 4 },
        { label: '2. Gözetim Bekleniyor', value: 5 },
        { label: '2. Gözetim Tamamlandı', value: 6 },
        { label: '2. Gözetim Tamamlanamadı', value: 7 },
      ]

export const iktmStatusDef = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2nd Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },
          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Not Documented',
            value: iktmStatus.UnCertified,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Belgelendirilmemiş',
            value: iktmStatus.UnCertified,
          },
        ]

  isFilter &&
    arr.unshift(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'All',
            value: hotelCertificateStatusEnum.All,
          }
        : {
            label: 'Tümü',
            value: hotelCertificateStatusEnum.All,
          }
    )

  return arr
}
export const hotelCertificateStatusList = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2nd Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },
          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]

  isFilter &&
    arr.unshift(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'All',
            value: hotelCertificateStatusEnum.All,
          }
        : {
            label: 'Tümü',
            value: hotelCertificateStatusEnum.All,
          }
    )

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          }
        : {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          }
    )
  return arr
}
export const hotelCertificateStatusListGetById = (passableStatusList?: any) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2nd Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },
          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          },
          {
            label: 'Dismissal From Probation',
            value: hotelCertificateStatusEnum.DismissalFromProbation,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          },
          {
            label: 'Gözetimden İptal',
            value: hotelCertificateStatusEnum.DismissalFromProbation,
          },
        ]

  if (passableStatusList) {
    arr = arr.filter((item) => passableStatusList.includes(item.value))
  }

  return arr
}

export const documentStatus =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Uploaded', value: true },
        { label: 'Non-existent', value: false },
      ]
    : [
        { label: 'İşletme Belgesi Yüklü', value: true },
        { label: 'İşletme Belgesi Yok', value: false },
      ]

export const roomCountList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: '30 Rooms And Below', value: 1 },
        { label: 'Between 30 And 49 Rooms', value: 2 },
        { label: '50 Rooms And Above', value: 3 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: '30 Oda ve Altı', value: 1 },
        { label: '30 ile 49 Oda Arası', value: 2 },
        { label: '50 Oda ve Üstü', value: 3 },
      ]

export const userTypeList: any = (updateId?: any) => {
  let arr =
    userRole === userTypeEnum.SuperAdmin
      ? localStorage.getItem(CookieName.Language) === 'en-US'
        ? [
            { label: 'Super Admin', value: userTypeEnum.SuperAdmin },
            { label: 'Call Center', value: userTypeEnum.CallCenter },
            {
              label: 'Audit Company Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Audit Company Person',
              value: userTypeEnum.AuditCompanyPerson,
            },
            { label: 'Facility Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Facility User', value: userTypeEnum.CompanyUser },
            // { label: 'TGA Admin', value: userTypeEnum.TgaAdmin },
            // {
            //   label: 'Green Website User',
            //   value: userTypeEnum.GreenWebSiteUser,
            // },
            {
              label: 'IKTM User',
              value: userTypeEnum.IKTMUser,
            },
            {
              label: 'Content Approval Team',
              value: userTypeEnum.ContentApprovalTeam,
            },
            {
              label: 'Carbon FootPrint User',
              value: userTypeEnum.CFPUser,
            },
            {
              label: 'Visual Content Editor',
              value: userTypeEnum.VisualContentEditor,
            },
          ]
        : [
            { label: 'Süper Admin', value: userTypeEnum.SuperAdmin },
            { label: 'Çağrı Merkezi', value: userTypeEnum.CallCenter },
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Yetkili',
              value: userTypeEnum.AuditCompanyPerson,
            },
            { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
            // { label: 'TGA Yönetici', value: userTypeEnum.TgaAdmin },
            // {
            //   label: 'Green Web Sitesi Kullanıcısı',
            //   value: userTypeEnum.GreenWebSiteUser,
            // },
            {
              label: 'İKTM Kullanıcısı',
              value: userTypeEnum.IKTMUser,
            },
            // {
            //   label: 'İçerik Onay Ekibi',
            //   value: userTypeEnum.ContentApprovalTeam,
            // },
            {
              label: 'Karbon Ayakİzi Kullanıcısı',
              value: userTypeEnum.CFPUser,
            },
            {
              label: 'Görsel İçerik Düzenleyicisi',
              value: userTypeEnum.VisualContentEditor,
            },
          ]
      : userRole === userTypeEnum.AuditCompanyAdmin ||
        userRole === userTypeEnum.AuditCompanyPerson
      ? localStorage.getItem(CookieName.Language) === 'en-US'
        ? [
            {
              label: 'Audit Company Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Audit Company Person',
              value: userTypeEnum.AuditCompanyPerson,
            },
            // { label: 'Company Admin', value: userTypeEnum.CompanyAdmin },
            // { label: 'Company User', value: userTypeEnum.CompanyUser },
          ]
        : [
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Yetkili',
              value: userTypeEnum.AuditCompanyPerson,
            },
            // { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
            // { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
          ]
      : userRole === userTypeEnum.TgaAdmin
      ? localStorage.getItem(CookieName.Language) === 'en-US'
        ? [
            { label: 'Company Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Company User', value: userTypeEnum.CompanyUser },
            {
              label: 'Green Website User',
              value: userTypeEnum.GreenWebSiteUser,
            },
          ]
        : [
            { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
            {
              label: 'Green Web Sitesi Kullanıcısı',
              value: userTypeEnum.GreenWebSiteUser,
            },
          ]
      : userRole === userTypeEnum.CallCenter
      ? localStorage.getItem(CookieName.Language) === 'en-US'
        ? [
            { label: 'Call Center', value: userTypeEnum.CallCenter },
            {
              label: 'Audit Company Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Audit Company Person',
              value: userTypeEnum.AuditCompanyPerson,
            },
            { label: 'Company Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Company User', value: userTypeEnum.CompanyUser },
            // { label: 'TGA Admin', value: userTypeEnum.TgaAdmin },
          ]
        : [
            { label: 'Çağrı Merkezi', value: userTypeEnum.CallCenter },
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Admin',
              value: userTypeEnum.AuditCompanyAdmin,
            },
            {
              label: 'Uygunluk Değerlendirme Kuruluşu Yetkili',
              value: userTypeEnum.AuditCompanyPerson,
            },
            { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
            { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
          ]
      : userRole === userTypeEnum.CompanyAdmin
      ? localStorage.getItem(CookieName.Language) === 'en-US'
        ? [{ label: 'Company User', value: userTypeEnum.CompanyUser }]
        : [{ label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser }]
      : localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          { label: 'Company Admin', value: userTypeEnum.CompanyAdmin },
          { label: 'Company User', value: userTypeEnum.CompanyUser },
        ]
      : [
          { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
          { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
        ]

  const userSession = getUserInfo()

  if (
    userSession?.id === updateId &&
    (userSession.userRole === userTypeEnum.AuditCompanyAdmin ||
      userSession.userRole === userTypeEnum.CompanyAdmin)
  ) {
    arr = arr.filter(
      (item) =>
        item.value !== userTypeEnum.AuditCompanyPerson &&
        item.value !== userTypeEnum.CompanyUser
    )
  }
  return arr
}

export const allUserTypesList = (): { label: string; value: number }[] => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          { label: 'Super Admin', value: userTypeEnum.SuperAdmin },
          { label: 'Call Center', value: userTypeEnum.CallCenter },
          {
            label: 'Audit Company Admin',
            value: userTypeEnum.AuditCompanyAdmin,
          },
          {
            label: 'Audit Company Person',
            value: userTypeEnum.AuditCompanyPerson,
          },
          { label: 'Facility Admin', value: userTypeEnum.CompanyAdmin },
          { label: 'Facility User', value: userTypeEnum.CompanyUser },
          // { label: 'TGA Admin', value: userTypeEnum.TgaAdmin },
          // {
          //   label: 'Green Website User',
          //   value: userTypeEnum.GreenWebSiteUser,
          // },
          {
            label: 'IKTM User',
            value: userTypeEnum.IKTMUser,
          },
          // {
          //   label: 'Content Approval Team',
          //   value: userTypeEnum.ContentApprovalTeam,
          // },
          {
            label: 'Carbon FootPrint User',
            value: userTypeEnum.CFPUser,
          },
          {
            label: 'Visual Content Editor',
            value: userTypeEnum.VisualContentEditor,
          },
        ]
      : [
          { label: 'Süper Admin', value: userTypeEnum.SuperAdmin },
          { label: 'Çağrı Merkezi', value: userTypeEnum.CallCenter },
          {
            label: 'Uygunluk Değerlendirme Kuruluşu Admin',
            value: userTypeEnum.AuditCompanyAdmin,
          },
          {
            label: 'Uygunluk Değerlendirme Kuruluşu Yetkili',
            value: userTypeEnum.AuditCompanyPerson,
          },
          { label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin },
          { label: 'Tesis Yetkili', value: userTypeEnum.CompanyUser },
          // { label: 'TGA Yönetici', value: userTypeEnum.TgaAdmin },
          // {
          //   label: 'Green Web Sitesi Kullanıcısı',
          //   value: userTypeEnum.GreenWebSiteUser,
          // },
          {
            label: 'İKTM Kullanıcısı',
            value: userTypeEnum.IKTMUser,
          },
          // {
          //   label: 'İçerik Onay Ekibi',
          //   value: userTypeEnum.ContentApprovalTeam,
          // },
          {
            label: 'Karbon Ayak İzi Kullanıcısı',
            value: userTypeEnum.CFPUser,
          },
          {
            label: 'Görsel İçerik Düzenleyicisi',
            value: userTypeEnum.VisualContentEditor,
          },
        ]
  return arr
}

export const userStatusList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Waiting For Approval',
          value: userStatusEnum.WaitingForApproval,
        },
        { label: 'Rejected', value: userStatusEnum.Rejected },
      ]
    : [
        { label: 'Onay Bekliyor', value: userStatusEnum.WaitingForApproval },
        { label: 'Reddedildi', value: userStatusEnum.Rejected },
      ]

export const FacilityAdminChangeList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Approved', value: userStatusEnum.Approved },
        {
          label: 'Waiting For Approval',
          value: userStatusEnum.WaitingForApproval,
        },
        { label: 'Rejected', value: userStatusEnum.Rejected },
      ]
    : [
        { label: 'Onaylanmış', value: userStatusEnum.Approved },
        { label: 'Onay Bekliyor', value: userStatusEnum.WaitingForApproval },
        { label: 'Reddedildi', value: userStatusEnum.Rejected },
      ]

export const statusList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Published', value: statusEnum.Published },
        { label: 'Waiting For Approval', value: statusEnum.WaitingForApproval },
        { label: 'Approved', value: statusEnum.Approved },
        { label: 'Rejected', value: statusEnum.Rejected },
        { label: 'Deleted', value: statusEnum.Deleted },
        {
          label: 'Waiting For Sms Approval',
          value: statusEnum.WaitingForSmsApproval,
        },
        { label: 'SmsApproval', value: statusEnum.SmsApproval },
        { label: 'Drafted', value: statusEnum.Drafted },
      ]
    : [
        { label: 'Yayında', value: statusEnum.Published },
        { label: 'Onay Bekleniyor', value: statusEnum.WaitingForApproval },
        { label: 'Onaylandı', value: statusEnum.Approved },
        { label: 'Reddedildi', value: statusEnum.Rejected },
        { label: 'Silindi', value: statusEnum.Deleted },
        {
          label: 'Sms Onayı Bekliyor',
          value: statusEnum.WaitingForSmsApproval,
        },
        { label: 'Sms Onaylandı', value: statusEnum.SmsApproval },
        { label: 'Taslak', value: statusEnum.Drafted },
      ]

export const auditStatusList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'All',
          value: 0,
        },
        {
          label: 'UDK Request',
          value: auditStatusEnum.RequestCanBeSent,
        },
        {
          label: 'Transfer Request',
          value: auditStatusEnum.RequestCanNotBeSent,
        },
      ]
    : [
        {
          label: 'Tümü',
          value: 0,
        },
        {
          label: 'UDK Talebi',
          value: auditStatusEnum.RequestCanBeSent,
        },
        {
          label: 'Transfer Talebi',
          value: auditStatusEnum.RequestCanNotBeSent,
        },
      ]

export const approvalAuditStatusList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Waiting for approval',
          value: approvalAuditStatusEnum.WaitingForApproval,
        },
        {
          label: 'Request Sent',
          value: approvalAuditStatusEnum.RequestSent,
        },
        { label: 'Approved', value: approvalAuditStatusEnum.Approved },
        { label: 'Rejected', value: approvalAuditStatusEnum.Rejected },
        { label: 'Canceled', value: approvalAuditStatusEnum.Canceled },
        { label: 'Auto canceled', value: approvalAuditStatusEnum.AutoCanceled },
        { label: 'Expired', value: approvalAuditStatusEnum.Expired },
      ]
    : [
        {
          label: 'Onay Bekleniyor',
          value: approvalAuditStatusEnum.WaitingForApproval,
        },
        {
          label: 'Talep Gönderildi',
          value: approvalAuditStatusEnum.RequestSent,
        },
        { label: 'Onaylandı', value: approvalAuditStatusEnum.Approved },
        { label: 'Reddedildi', value: approvalAuditStatusEnum.Rejected },
        { label: 'İptal Edildi', value: approvalAuditStatusEnum.Canceled },
        {
          label: 'Otomatik İptal Edildi',
          value: approvalAuditStatusEnum.AutoCanceled,
        },
        { label: 'Süresi Doldu', value: approvalAuditStatusEnum.Expired },
      ]

export const KPIList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { color: '#6565CE', label: 'Energy', value: 1 },
        { color: '#EBAF38', label: 'GreenHouse Gas ', value: 2 },
        { color: '#4EBBD6', label: 'Water', value: 3 },
        { color: '#64BF5C', label: 'Waste Products', value: 4 },
        { color: '#D5762D', label: 'Waste Parsing', value: 5 },
        { color: '#DC3545', label: 'Natural Gas', value: 6 },
      ]
    : [
        { color: '#6565CE', label: 'Enerji', value: 1 },
        { color: '#EBAF38', label: 'Sera Gazı', value: 2 },
        { color: '#4EBBD6', label: 'Su', value: 3 },
        { color: '#64BF5C', label: 'Atık Ürünler', value: 4 },
        { color: '#D5762D', label: 'Atık Ayrıştırma', value: 5 },
        { color: '#DC3545', label: 'Doğal Gaz', value: 6 },
      ]
export const ChartTypes =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Across Turkey', value: 1 },
        { label: 'Across City', value: 2 },
        { label: 'Across By Capacity', value: 3 },
      ]
    : [
        { label: 'Türkiye Genelinde', value: 1 },
        { label: 'Şehir Genelinde', value: 2 },
        { label: 'Kapasiteye göre', value: 3 },
      ]
export const MonthList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 },
      ]
    : [
        { label: 'Ocak', value: 1 },
        { label: 'Şubat', value: 2 },
        { label: 'Mart', value: 3 },
        { label: 'Nisan', value: 4 },
        { label: 'Mayıs', value: 5 },
        { label: 'Haziran', value: 6 },
        { label: 'Temmuz', value: 7 },
        { label: 'Ağustos', value: 8 },
        { label: 'Eylül', value: 9 },
        { label: 'Ekim', value: 10 },
        { label: 'Kasım', value: 11 },
        { label: 'Aralık', value: 12 },
      ]

export const yearList = [
  { label: '2020', value: 2020 },
  { label: '2021', value: 2021 },
  { label: '2022', value: 2022 },
  { label: '2023', value: 2023 },
  { label: '2024', value: 2024 },
  { label: '2025', value: 2025 },
  { label: '2026', value: 2026 },
]

export const uploaderTrTexts = {
  labelIdle:
    'Dosyaları sürükleyip bırakın veya <span class="action"> buraya tıklayın </span>',
  labelInvalidField: 'Alan geçersiz dosyalar içeriyor',
  labelFileWaitingForSize: 'Boyut bekleniyor',
  labelFileSizeNotAvailable: 'Boyut mevcut değil',
  labelFileLoading: 'Yükleniyor',
  labelFileLoadError: 'Yükleme sırasında hata',
  labelFileProcessing: 'Yükleniyor',
  labelFileProcessingComplete: 'Yükleme Tamamlandı',
  labelFileProcessingAborted: 'Yükleme iptal edildi',
  labelFileProcessingError: 'Yükleme hatası',
  labelFileProcessingRevertError: 'Geri alma sırasında hata',
  labelFileRemoveError: 'Kaldırma sırasında hata',
  // labelTapToCancel: 'iptal etmek için dokunun',
  labelTapToCancel: '',
  labelTapToRetry: 'tekrar denemek için dokunun',
  labelTapToUndo: 'geri almak için dokunun',
  labelButtonRemoveItem: 'Kaldır',
  labelButtonAbortItemLoad: 'İptal',
  labelButtonRetryItemLoad: 'Yeniden Dene',
  labelButtonAbortItemİşleniyor: 'İptal',
  labelButtonUndoItemİşleme: 'Geri Al',
  labelButtonRetryItemProcessing: 'Yeniden Dene',
  labelButtonProcessItem: 'Yükle',
  labelMaxFileSizeExceeded: 'Dosya çok büyük',
  labelMaxFileSize: 'Maksimum dosya boyutu {filesize} dir',
  labelMaxTotalFileSizeExceeded: 'Maksimum toplam dosya boyutu aşıldı',
  labelMaxTotalFileSize: "Maksimum toplam dosya boyutu {filesize}'dir",
  labelFileTypeNotAllowed: 'Geçersiz dosya türü',
  fileValidateTypeLabelExpectedTypes:
    'Bekleyin {allButLastType} veya {lastType}',
  imageValidateSizeLabelFormatError: 'Desteklenmeyen görüntü türü',
  imageValidateSizeLabelImageSizeTooSmall: 'Görüntü çok küçük',
  imageValidateSizeLabelImageSizeTooBig: 'Görüntü çok büyük',
  imageValidateSizeLabelImageResolutionTooLow: 'Çözünürlük çok düşük',
  imageValidateSizeLabelImageResolutionTooHigh: 'Çözünürlük çok yüksek',
}

export const uploaderEnTexts = {
  labelIdle: 'Drag & drop files or <span class="action">click here</span>',
  labelInvalidField: 'This field contains invalid files',
  labelFileWaitingForSize: 'Waiting for file size',
  labelFileSizeNotAvailable: 'Size not available',
  labelFileLoading: 'Loading file',
  labelFileLoadError: 'Error during file load',
  labelFileProcessing: 'Uploading',
  labelFileProcessingComplete: 'Upload complete',
  labelFileProcessingAborted: 'Upload aborted',
  labelFileProcessingError: 'Upload error',
  labelFileProcessingRevertError: 'Error reverting upload',
  labelFileRemoveError: 'Error removing file',
  labelTapToCancel: 'Tap to cancel',
  labelTapToRetry: 'Tap to retry',
  labelTapToUndo: 'Tap to undo',
  labelButtonRemoveItem: 'Remove',
  labelButtonAbortItemLoad: 'Abort',
  labelButtonRetryItemLoad: 'Retry',
  labelButtonAbortItemProcessing: 'Abort',
  labelButtonUndoItemProcessing: 'Undo',
  labelButtonRetryItemProcessing: 'Retry',
  labelButtonProcessItem: 'Upload',
  labelMaxFileSizeExceeded: 'File is too large',
  labelMaxFileSize: 'Maximum file size is {filesize}',
  labelMaxTotalFileSizeExceeded: 'Maximum total file size exceeded',
  labelMaxTotalFileSize: 'Maximum total file size is {filesize}',
  labelFileTypeNotAllowed: 'Invalid file type',
  fileValidateTypeLabelExpectedTypes:
    'Please select {allButLastType} or {lastType}',
  imageValidateSizeLabelFormatError: 'Unsupported image type',
  imageValidateSizeLabelImageSizeTooSmall: 'Image is too small',
  imageValidateSizeLabelImageSizeTooBig: 'Image is too large',
  imageValidateSizeLabelImageResolutionTooLow: 'Resolution is too low',
  imageValidateSizeLabelImageResolutionTooHigh: 'Resolution is too high',
}

export const AuditResultEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Documented',
          value: auditResultEnum.Documented,
        },
        {
          label: 'Undocumented',
          value: auditResultEnum.Undocumented,
        },
        { label: 'Certificated', value: auditResultEnum.Certificated },
      ]
    : [
        {
          label: 'Belge Verilebilir',
          value: auditResultEnum.Documented,
        },
        {
          label: 'Belge Verilemez',
          value: auditResultEnum.Undocumented,
        },
        { label: 'Belge Verilmiştir', value: auditResultEnum.Certificated },
      ]

export const isOpenEnumList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Open', value: 2 },
        { label: 'Close', value: 1 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Açık', value: 2 },
        { label: 'Kapalı', value: 1 },
      ]

export const auditTypeList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Self Audities', value: 1 },
        { label: 'Other Audities', value: 2 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Kendi denetimlerim', value: 1 },
        { label: 'Diğer Denetimler', value: 2 },
      ]

export const isOpenEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Open', value: false },
        { label: 'Close', value: true },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Açık', value: false },
        { label: 'Kapalı', value: true },
      ]
export const ReportPageTypeOptions = [
  {
    label: ReportPageTypes.CertificationProcessCompletedList,
    value: ReportPageTypes.CertificationProcessCompletedList,
  },
]

export const NotificationTypeFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Create Hotel Notice', value: 1 },
        { label: 'Update Hotel Notice', value: 2 },
        { label: 'Hotel Revision Notice', value: 8 },
        { label: 'Create Hotel Certificate Notice', value: 3 },
        { label: 'Update Hotel Certificate Notice', value: 4 },
        { label: 'Certificate Revision Notice', value: 9 },
        { label: 'Audit Request Notice', value: 19 },
        { label: 'Audit Approval Notice', value: 20 },
        { label: 'Audit Rejection Notice', value: 21 },
        { label: 'Audit Transfer Request Notice', value: 22 },
        { label: 'Audit Transfer Approval Notice', value: 23 },
        { label: 'Audit Transfer Rejection Notice', value: 24 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Tesis Ekleme Bildirimi', value: 1 },
        { label: 'Tesis Güncelleme Bildirimi', value: 2 },
        { label: 'Tesis Revize Notu Bildirimi', value: 8 },
        { label: 'Sertifika Ekleme Bildirimi', value: 3 },
        { label: 'Sertifika Güncelleme Bildirimi', value: 4 },
        { label: 'Sertifika Revize Notu Bildirimi', value: 9 },
        { label: 'Denetim Talebi Bildirimi', value: 19 },
        { label: 'Denetim Onaylama Bildirimi', value: 20 },
        { label: 'Denetim Reddedilme Bildirimi', value: 21 },
        { label: 'Denetim Transfer Talebi Bildirimi', value: 22 },
        { label: 'Denetim Transfer Onaylama Bildirimi', value: 23 },
        { label: 'Denetim Transfer Reddedilme Bildirimi', value: 24 },
      ]

export const isReadEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: isReadEnum.All },
        { label: 'Read', value: isReadEnum.Read },
        { label: 'Unread', value: isReadEnum.Unread },
      ]
    : [
        { label: 'Tümü', value: isReadEnum.All },
        { label: 'Okunmuş', value: isReadEnum.Read },
        { label: 'Okunmamış', value: isReadEnum.Unread },
      ]

export const ApplicationStatusEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: ImageStatusFilterEnum.All },
        {
          label: 'Pending Approval',
          value: ImageStatusFilterEnum.WaitingForApproval,
        },
        { label: 'Rejected', value: ImageStatusFilterEnum.Rejected },
      ]
    : [
        { label: 'Tümü', value: ImageStatusFilterEnum.All },
        {
          label: 'Onayda Bekleyen',
          value: ImageStatusFilterEnum.WaitingForApproval,
        },
        { label: 'Reddedildi', value: ImageStatusFilterEnum.Rejected },
      ]

export const ConsentLetterStatusEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: ConsentLetterStatusFilterEnum.All },
        {
          label: 'Pending Approval',
          value: ConsentLetterStatusFilterEnum.WaitingForApproval,
        },
        { label: 'Approved', value: ConsentLetterStatusFilterEnum.Approved },
        { label: 'Rejected', value: ConsentLetterStatusFilterEnum.Rejected },
      ]
    : [
        { label: 'Tümü', value: ConsentLetterStatusFilterEnum.All },
        {
          label: 'Onayda Bekleyen',
          value: ConsentLetterStatusFilterEnum.WaitingForApproval,
        },
        { label: 'Onaylandı', value: ConsentLetterStatusFilterEnum.Approved },
        { label: 'Reddedildi', value: ConsentLetterStatusFilterEnum.Rejected },
      ]
export const FacilityRevisionFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        {
          label: 'Revised Requested',
          value: hotelRevisedEnum.RevisedRequested,
        },
        {
          label: 'Revised Completely Done',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revised Rejected', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revised Partially Done',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Revised Requested By Super Admin',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
        {
          label: 'Cancelled Revision',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Revize İstendi', value: hotelRevisedEnum.RevisedRequested },
        {
          label: 'Revize Yapıldı',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revize Reddedildi', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revize Kısmi Olarak Yapıldı',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Admin Revize Talebi',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
        {
          label: 'Revize Geri Çekildi',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
export const FacilityRevisionAdminFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        {
          label: 'Revised Requested',
          value: hotelRevisedEnum.RevisedRequested,
        },
        {
          label: 'Revised Completely Done',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revised Rejected', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revised Partially Done',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Revised Requested By Super Admin',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
        {
          label: 'Cancelled Revision',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Revize İstendi', value: hotelRevisedEnum.RevisedRequested },
        {
          label: 'Revize Yapıldı',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revize Reddedildi', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revize Kısmi Olarak Yapıldı',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Admin Revize Talebi',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
        {
          label: 'Revize Geri Çekildi',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
export const hotelRevisedStatusEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Approve',
          value: hotelRevisedStatusEnum.Approve,
        },
        {
          label: 'Reject',
          value: hotelRevisedStatusEnum.Reject,
        },
      ]
    : [
        { label: 'Onayla', value: hotelRevisedStatusEnum.Approve },
        {
          label: 'Reddet',
          value: hotelRevisedStatusEnum.Reject,
        },
      ]

export const hotelRevisedEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        {
          label: 'Revised Requested',
          value: hotelRevisedEnum.RevisedRequested,
        },
        {
          label: 'Revised Completely Done',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revised Rejected', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revised Partially Done',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Revised Not Requested',
          value: hotelRevisedEnum.RevisedNotRequested,
        },
        {
          label: 'Revised Requested By Super Admin',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },

        {
          label: 'Cancelled Revision',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Revize İstendi', value: hotelRevisedEnum.RevisedRequested },
        {
          label: 'Revize Yapıldı',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revize Reddedildi', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revize Kısmi Olarak Yapıldı',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },
        {
          label: 'Revize Talep Edilmedi',
          value: hotelRevisedEnum.RevisedNotRequested,
        },
        {
          label: 'Admin Revize Talebi',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
        {
          label: 'Revize Geri Çekildi',
          value: hotelRevisedEnum.ReviseRetreated,
        },
      ]
export const hotelRevisedStatusEnumForFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Approve',
          value: hotelRevisedStatusEnum.Approve,
        },
        {
          label: 'Reject',
          value: hotelRevisedStatusEnum.Reject,
        },
      ]
    : [
        { label: 'Onayla', value: hotelRevisedStatusEnum.Approve },
        {
          label: 'Reddet',
          value: hotelRevisedStatusEnum.Reject,
        },
      ]

export const IsFacilityClosedEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Yes', value: 1 },
        { label: 'No', value: 2 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Evet', value: 1 },
        { label: 'Hayır', value: 2 },
      ]

export const hotelCertificateRevisedEnumFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        {
          label: 'Revised Requested',
          value: hotelRevisedEnum.RevisedRequested,
        },
        {
          label: 'Revised Completely Done',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revised Rejected', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revised Partially Done',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },

        {
          label: 'Revised Requested By Super Admin',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Revize İstendi', value: hotelRevisedEnum.RevisedRequested },
        {
          label: 'Revize Yapıldı',
          value: hotelRevisedEnum.RevisedCompletelyDone,
        },
        { label: 'Revize Reddedildi', value: hotelRevisedEnum.RevisedRejected },
        {
          label: 'Revize Kısmi Olarak Yapıldı',
          value: hotelRevisedEnum.RevisedPartiallyDone,
        },

        {
          label: 'Admin Revize Talebi',
          value: hotelRevisedEnum.RevisedRequestedBySuperAdmin,
        },
      ]

export const HotelCertificateStatusNotIktmRulesList = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2nd Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },
          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Dismissal From Probation',
            value: hotelCertificateStatusEnum.DismissalFromProbation,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },
          {
            label: '2. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage2,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Gözetimden İptal',
            value: hotelCertificateStatusEnum.DismissalFromProbation,
          },
        ]

  isFilter &&
    arr.unshift(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'All',
            value: hotelCertificateStatusEnum.All,
          }
        : {
            label: 'Tümü',
            value: hotelCertificateStatusEnum.All,
          }
    )

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          }
        : {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          }
    )

  return arr
}

export const RegistrationStatus =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Registered', value: 1 },
        { label: 'Deleted', value: 8 },
      ]
    : [
        { label: 'Kayıtlı', value: 1 },
        { label: 'Silindi', value: 8 },
      ]

export const RegistrationPendingStatus =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'Pending',
          value: 11,
        },
        { label: 'Deleted', value: 8 },
      ]
    : [
        {
          label: 'Beklemede',
          value: 11,
        },
        { label: 'Silindi', value: 8 },
      ]

export const RegistrationStatusFilter = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'All',
            value: 0,
          },
          {
            label: 'Registered',
            value: 1,
          },
          {
            label: 'Deleted',
            value: 8,
          },
        ]
      : [
          {
            label: 'Tümü',
            value: 0,
          },
          {
            label: 'Kayıtlı',
            value: 1,
          },
          {
            label: 'Silindi',
            value: 8,
          },
        ]

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Pending',
            value: 11,
          }
        : {
            label: 'Beklemede',
            value: 11,
          }
    )

  return arr
}

export const IsEnteredRenewalPeriod =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Entering the Renewal Period', value: 1 },
        { label: 'Not Entering the Renewal Period', value: 2 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Yenileme Dönemine Girmiş', value: 1 },
        { label: 'Yenileme Dönemine Girmemiş', value: 2 },
      ]

export const RegistrationStatusFilterForFacility = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'Registered',
            value: 1,
          },
          {
            label: 'Deleted',
            value: 8,
          },
        ]
      : [
          {
            label: 'Kayıtlı',
            value: 1,
          },
          {
            label: 'Silindi',
            value: 8,
          },
        ]

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Suspended',
            value: 12,
          }
        : {
            label: 'Askıda',
            value: 12,
          }
    )

  return arr
}
export const emissionFactorTypeEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'GridSuppliedElectricity', value: 1 },
        { label: 'NaturalGas', value: 2 },
        { label: 'LocalCoal', value: 3 },
        { label: 'ImportedCoal', value: 4 },
        { label: 'CylinderGas70Butan30Propan', value: 5 },
        { label: 'CylinderGas95Propan', value: 6 },
        { label: 'LiquefiedPetroleumGasKg', value: 7 },
        { label: 'LiquefiedPetroleumGasM3', value: 8 },
        { label: 'LiquefiedNaturalGasKg', value: 9 },
        { label: 'LiquefiedNaturalGasM3', value: 10 },
        { label: 'CompressedNaturalGasKg', value: 11 },
        { label: 'CompressedNaturalGasM3', value: 12 },
        { label: 'WoodAndWoodResidues', value: 13 },
        { label: 'FuelOil1Kg', value: 14 },
        { label: 'FuelOil1M3', value: 15 },
        { label: 'FuelOil2Kg', value: 16 },
        { label: 'FuelOil2M3', value: 17 },
        { label: 'FuelOil4Kg', value: 18 },
        { label: 'FuelOil4M3', value: 19 },
        { label: 'FuelOil5Kg', value: 20 },
        { label: 'FuelOil5M3', value: 21 },
        { label: 'FuelOil6Kg', value: 22 },
        { label: 'FuelOil6M3', value: 23 },
        { label: 'Benzine', value: 24 },
        { label: 'Diesel', value: 25 },
        { label: 'PurchasedRenewableElectricity', value: 26 },
        {
          label: 'PhotovoltaicBasedElectricityProducedattheFacility',
          value: 27,
        },
        { label: 'SolarWaterHeatingPanelsintheFacility', value: 28 },
        { label: ' ElectricEnergyRenewabilityRate', value: 29 },
      ]
    : [
        { label: 'Şebekeden Temin Edilen Elektrik', value: 1 },
        { label: 'Doğalgaz', value: 2 },
        { label: 'Yerli Kömür', value: 3 },
        { label: 'İthal Kömür', value: 4 },
        { label: 'Tüp Gaz (%70 Bütan + %30 Propan)', value: 5 },
        { label: 'Tüp Gaz (%95 Propan)', value: 6 },
        { label: 'Sıvı Petrol Gazı KG (LPG)', value: 7 },
        { label: 'Sıvı Petrol Gazı M3 (LPG)', value: 8 },
        { label: 'Sıvı Doğal Gazı KG (LNG)', value: 9 },
        { label: 'Sıvı Doğal Gazı M3 (LNG)', value: 10 },
        { label: 'Sıkıştırılmış Doğal Gaz KG (CNG)', value: 11 },
        { label: 'Sıkıştırılmış Doğal Gaz M3 (CNG)', value: 12 },
        { label: 'Odun ve Odun Artıkları', value: 13 },
        { label: 'Fuel Oil 1 KG', value: 14 },
        { label: 'Fuel Oil 1 M3', value: 15 },
        { label: 'Fuel Oil 2 KG', value: 16 },
        { label: 'Fuel Oil 2 M3', value: 17 },
        { label: 'Fuel Oil 4 KG', value: 18 },
        { label: 'Fuel Oil 4 M3', value: 19 },
        { label: 'Fuel Oil 5 KG', value: 20 },
        { label: 'Fuel Oil 5 M3', value: 21 },
        { label: 'Fuel Oil 6 KG', value: 22 },
        { label: 'Fuel Oil 6 M3', value: 23 },
        { label: 'Benzin', value: 24 },
        { label: 'Mazot', value: 25 },
        { label: 'Satın Alınan Yenilenebilir Elektrik', value: 26 },
        { label: 'Tesiste Üretilen Fotovoltaik Bazlı Elektrik', value: 27 },
        { label: 'Tesiste Güneş Enerjili Su Isıtma Panelleri', value: 28 },
        { label: 'Elektrik Enerjisi Yenilenebilirlik Oranları', value: 29 },
      ]

export const emissionFactorUnitEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'kWh', value: 1 },
        { label: 'kg', value: 2 },
        { label: 'm3', value: 3 },
        { label: 'ton', value: 4 },
        { label: 'liter', value: 5 },
        { label: '%', value: 6 },
        { label: 'm2', value: 7 },
      ]
    : [
        { label: 'kWh', value: 1 },
        { label: 'kg', value: 2 },
        { label: 'm3', value: 3 },
        { label: 'ton', value: 4 },
        { label: 'litre', value: 5 },
        { label: '%', value: 6 },
        { label: 'm2', value: 7 },
      ]
export const emissionFactorUnitEnum2 =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'kg', value: 2 },
        { label: 'm3', value: 3 },
      ]
    : [
        { label: 'kg', value: 2 },
        { label: 'm3', value: 3 },
      ]

export const emissionFactorTypeEnum2 =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Grid-Supplied Electricity', value: 1 },
        { label: 'Natural Gas', value: 2 },
        { label: 'Domestic Coal', value: 3 },
        { label: 'Imported Coal', value: 4 },
        { label: 'LPG Blend (70% Butane + 30% Propane)', value: 5 },
        { label: 'LPG (95% Propane)', value: 6 },
        { label: 'Liquefied Petroleum Gas', value: 7 },
        { label: 'Liquefied Natural Gas', value: 8 },
        { label: 'Compressed Natural Gas', value: 9 },
        { label: 'Wood And Wood Residues', value: 10 },
        { label: 'Fuel Oil 1', value: 11 },
        { label: 'Fuel Oil 2', value: 12 },
        { label: 'Fuel Oil 4', value: 13 },
        { label: 'Fuel Oil 5', value: 14 },
        { label: 'Fuel Oil 6', value: 15 },
        { label: 'Gasoline', value: 16 },
        { label: 'Diesel', value: 17 },
        { label: 'Purchased Renewable Electricity', value: 18 },
        {
          label: 'Photovoltaic Based Electricity Produced at the Facility',
          value: 19,
        },
        { label: 'Solar Water Heating Panels in the Facility', value: 20 },
      ]
    : [
        { label: 'Şebekeden Temin Edilen Elektrik', value: 1 },
        { label: 'Doğalgaz', value: 2 },
        { label: 'Yerli Kömür', value: 3 },
        { label: 'İthal Kömür', value: 4 },
        { label: 'Tüp Gaz (%70 Bütan + %30 Propan)', value: 5 },
        { label: 'Tüp Gaz (%95 Propan)', value: 6 },
        { label: 'Sıvı Petrol Gazı (LPG)', value: 7 },
        { label: 'Sıvı Doğal Gazı (LNG)', value: 8 },
        { label: 'Sıkıştırılmış Doğal Gaz (CNG)', value: 9 },
        { label: 'Odun ve Odun Artıkları', value: 10 },
        { label: 'Fuel Oil 1', value: 11 },
        { label: 'Fuel Oil 2', value: 12 },
        { label: 'Fuel Oil 4', value: 13 },
        { label: 'Fuel Oil 5', value: 14 },
        { label: 'Fuel Oil 6', value: 15 },
        { label: 'Benzin', value: 16 },
        { label: 'Mazot', value: 17 },
        { label: 'Satın Alınan Yenilenebilir Elektrik', value: 18 },
        { label: 'Tesiste Üretilen Fotovoltaik Bazlı Elektrik', value: 19 },
        { label: 'Tesiste Güneş Enerjili Su Isıtma Panelleri', value: 20 },
      ]

export const restaurantCertificateStatusList = (isFilter?: boolean) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]

  isFilter &&
    arr.unshift(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'All',
            value: hotelCertificateStatusEnum.All,
          }
        : {
            label: 'Tümü',
            value: hotelCertificateStatusEnum.All,
          }
    )

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          }
        : {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          }
    )
  return arr
}

export const RestaurantCertificateStatusNotIktmRulesList = (
  isFilter?: boolean
) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
        ]

  isFilter &&
    arr.unshift(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'All',
            value: hotelCertificateStatusEnum.All,
          }
        : {
            label: 'Tümü',
            value: hotelCertificateStatusEnum.All,
          }
    )

  isFilter &&
    arr.push(
      localStorage.getItem(CookieName.Language) === 'en-US'
        ? {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          }
        : {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          }
    )

  return arr
}

export const InProgressStateInfoRestaurantEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Verification In Process for Stage 1', value: 1 },
        { label: 'In the Certification Process', value: 3 },
      ]
    : [
        { label: '1. Aşama için Belgelendirme Sürecinde', value: 1 },
        { label: 'Sertifikalandırma Sürecinde', value: 3 },
      ]

export const restaurantCertificateStatusListGetById = (
  passableStatusList?: any
) => {
  let arr =
    localStorage.getItem(CookieName.Language) === 'en-US'
      ? [
          {
            label: 'In the Certification/Documentation Process',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1st Tier Verified',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Certified',
            value: hotelCertificateStatusEnum.Certified,
          },

          {
            label: 'Not Eligible',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Left the Process',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Expired',
            value: hotelCertificateStatusEnum.Expired,
          },
        ]
      : [
          {
            label: 'Belgelendirme Sürecinde',
            value: hotelCertificateStatusEnum.CertificationProcess,
          },
          {
            label: '1. Aşama Belge Verildi',
            value: hotelCertificateStatusEnum.CertificateApprovedStage1,
          },

          {
            label: 'Sertifika Verildi',
            value: hotelCertificateStatusEnum.Certified,
          },
          {
            label: 'Uygun Görülmedi',
            value: hotelCertificateStatusEnum.NotConsideredAppropriate,
          },
          {
            label: 'Süreçten Ayrıldı',
            value: hotelCertificateStatusEnum.LeftTheProcess,
          },
          {
            label: 'Süresi Bitti',
            value: hotelCertificateStatusEnum.Expired,
          },
        ]

  if (passableStatusList) {
    arr = arr.filter((item) => passableStatusList.includes(item.value))
  }

  return arr
}

export const NotificationTypeRestaurantFilter =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Create User Notice', value: 5 },
        { label: 'Create Restaurant Notice', value: 11 },
        { label: 'Update Restaurant Notice', value: 12 },
        { label: 'Create Restaurant Certificate Notice', value: 13 },
        { label: 'Update Restaurant Certificate Notice', value: 14 },
        { label: 'Restaurant Admin Revised Notice', value: 15 },
        { label: 'Restaurant Certificate Admin Revised Notice', value: 16 },
        { label: 'Restaurant Certificate Revision Notice', value: 17 },
        { label: 'Restaurant Certificate Revision Notice', value: 18 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'Kullanıcı Ekleme Bildirimi', value: 5 },
        { label: 'Restoran Ekleme Bildirimi', value: 11 },
        { label: 'Restoran Güncelleme Bildirimi', value: 12 },
        { label: 'Restoran Sertifika Ekleme Bildirimi', value: 13 },
        { label: 'Restoran Sertifika Güncelleme Bildirimi', value: 14 },
        { label: 'Restoran Admin Revize Talebi Bildirimi', value: 15 },
        {
          label: 'Restoran Sertifika Admin Revize Talebi Bildirimi',
          value: 16,
        },
        { label: 'Restoran Revize Notu Bildirimi', value: 17 },
        { label: 'Restoran Sertifika Revize Notu Bildirimi', value: 18 },
      ]

export const AuditCompanyEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: '1st Tier Verified', value: 1 },
        { label: '2nd Tier Verified', value: 2 },
        { label: 'Certified', value: 3 },
        { label: 'No Authority', value: 8 },
      ]
    : [
        { label: '1. Aşama Belge Verildi', value: 1 },
        { label: '2. Aşama Belge Verildi', value: 2 },
        { label: 'Sertifika Verildi', value: 3 },
        { label: 'Yetki Yok', value: 8 },
      ]

export const isPreviousCertificateStatus =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Initial Documentation - 1st Stage', value: 1 },
        { label: 'Initial Certification - 2nd Stage ', value: 11 },
        { label: 'Initial Certification - 3rd Stage ', value: 12 },
        { label: '1st stage renewed', value: 2 },
        { label: 'Shifted from 1 to 2', value: 3 },
        { label: 'Shifted from 1 to 3', value: 4 },
        { label: '2nd stage renewed', value: 6 },
        { label: 'Shifted from 2 to 1', value: 5 },
        { label: 'Shifted from 2 to 3', value: 7 },
        { label: '3rd stage renewed', value: 10 },
        { label: 'Shifted from 3 to 1', value: 8 },
        { label: 'Shifted from 3 to 2', value: 9 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: 'İlk Belgelendirme - 1. Aşama', value: 1 },
        { label: 'İlk Belgelendirme - 2. Aşama', value: 11 },
        { label: 'İlk Belgelendirme - 3. Aşama', value: 12 },
        { label: '1. Aşama yenilendi', value: 2 },
        { label: '1’den 2’ye geçti', value: 3 },
        { label: '1’den 3’e geçti', value: 4 },
        { label: '2. Aşama yenilendi', value: 6 },
        { label: '2’den 1’e geçti', value: 5 },
        { label: '2’den 3’e geçti', value: 7 },
        { label: '3. Aşama yenilendi', value: 10 },
        { label: '3’den 1’e geçti', value: 8 },
        { label: '3’den 2’ye geçti', value: 9 },
      ]
export const InProgressStateCertificateInfoEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Verification In Process for Stage 1', value: 1 },
        { label: 'Verification In Process for Stage 2', value: 2 },
        { label: 'In the Certification Process', value: 3 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: '1. Aşama için Belgelendirme Sürecinde', value: 1 },
        { label: '2. Aşama için Belgelendirme Sürecinde', value: 2 },
        { label: 'Sertifikalandırma Sürecinde', value: 3 },
      ]

export const InProgressStateInfoRestaurantCertificateEnum =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'All', value: 0 },
        { label: 'Verification In Process for Stage 1', value: 1 },
        { label: 'In the Certification Process', value: 3 },
      ]
    : [
        { label: 'Tümü', value: 0 },
        { label: '1. Aşama için Belgelendirme Sürecinde', value: 1 },
        { label: 'Sertifikalandırma Sürecinde', value: 3 },
      ]

export const CompanyAdminUserList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [{ label: 'Company Admin', value: userTypeEnum.CompanyAdmin }]
    : [{ label: 'Tesis Admin', value: userTypeEnum.CompanyAdmin }]

export const carbonDataListStatus =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        {
          label: 'All',
          value: 0,
        },
        {
          label: 'Waiting For Approval',
          value: approvalAuditStatusEnum.WaitingForApproval,
        },
        {
          label: 'Requested Revision',
          value: approvalAuditStatusEnum.RevisionRequested,
        },
        {
          label: 'Approved',
          value: approvalAuditStatusEnum.Approved,
        },
      ]
    : [
        {
          label: 'Tümü',
          value: 0,
        },

        {
          label: 'Onay Bekleniyor',
          value: approvalAuditStatusEnum.WaitingForApproval,
        },
        {
          label: 'Revize Talep Edildi',
          value: approvalAuditStatusEnum.RevisionRequested,
        },
        {
          label: 'Onaylanmış',
          value: approvalAuditStatusEnum.Approved,
        },
      ]

export const RegistrationStatusHotelList =
  localStorage.getItem(CookieName.Language) === 'en-US'
    ? [
        { label: 'Registered', value: 1 },
        { label: 'Deleted', value: 8 },
        { label: 'Suspended', value: 12 },
      ]
    : [
        { label: 'Kayıtlı', value: 1 },
        { label: 'Silindi', value: 8 },
        { label: 'Askıda', value: 12 },
      ]
